import { render } from "./tenantCard.vue?vue&type=template&id=d3a6e5ec&scoped=true"
import script from "./tenantCard.vue?vue&type=script&lang=js"
export * from "./tenantCard.vue?vue&type=script&lang=js"

import "./tenantCard.vue?vue&type=style&index=0&id=d3a6e5ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3a6e5ec"]])

export default __exports__